import React from "react";
import Title from "../../ui/Title";

const EmergingTrends = () => {
  return (
    <div id="emerging-trends-in-caregiving" className="scroll-mt-24">
      <Title title="Emerging Trends in Caregiving" className="mb-6" />

      <div className="space-y-4 text-softBlack leading-loose text-base font-normal">
        <p>
          Caregiving is influenced by various factors, such as social and
          demographic shifts, reforms in healthcare, and technological
          advancements. To provide holistic support to caregivers and remain
          responsive to changing realities, it is important to take note of the
          trends that influence caregiving. For example, demographic shifts like
          the rise in the global aging population will lead to a massive rise in
          the number of older adults who need care in the near future. In turn,
          shrinking family sizes and fewer relatives in a generation will
          contribute to a decline in the number of potential family caregivers.
          Economic factors and workplace inequalities are also leading many care
          professionals to leave the sector altogether, further exacerbating the
          decline in the number of potential caregivers for the rising number of
          older adults. Data from the United States cited in the follo suggest a
          rise in both remote caregivers who take care of a loved one from a
          distance, and multigenerational households. These caregivers face
          unique and hidden challenges, and it is important to highlight their
          needs and offer tailored support. Meanwhile, the advancements in
          technology have contributed to the evolution of many tools that can
          support caregivers and help reduce their load. Caregiver-centered
          models offer a fresh perspective and direction to create a supportive
          environment for caregivers.
        </p>
        <p>
          In this section, we share some emerging trends in the world of
          caregiving that are critical to understanding the evolving care
          landscape and informing future responses.
        </p>
      </div>
    </div>
  );
};

export default EmergingTrends;
